export interface ScanLicenseDiskDocumentResponse {
    vehicleId?: string | null,
    documentId?: string | null,
    scanMethodEnum: ScanMethodEnum;
    success: boolean;
}

export const ScanMethodEnum = {
    UnableToMap: -1,
    Barcode: 0,
    OCR: 1
}

export type ScanMethodEnum = (typeof ScanMethodEnum)[keyof typeof ScanMethodEnum];